/* ─── 平台/设备检测 ───
 * 仅用于「按平台降级渲染策略」，不做业务分支。
 */

/**
 * iOS / iPadOS 检测。
 * iOS 全系浏览器(含 iOS Chrome / Edge)底层都是 WebKit，对带 `backdrop-filter` 的元素做
 * transform/尺寸/透明度动画时会逐帧重新栅格化背后模糊 → 严重掉帧（Android Blink、桌面均无此问题）。
 * 故凡是「会动起来的毛玻璃浮层」在 iOS 上需降级为无 backdrop-filter 的近似实色观感。
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const iOSDevice = /iP(hone|od|ad)/.test(ua);
  // iPadOS 13+ 默认按桌面 Safari 上报(platform=MacIntel)，靠多点触控把它与真 Mac 区分开
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return iOSDevice || iPadOS;
}
